import { useAtomValue } from 'jotai';
import { cn } from '@localagent/ui/lib/utils';
import { liveFeedUnseenCountAtom } from '../../stores/sdk/live-feed-atom';

export function NotificationNavBadge({ compact = false }: { compact?: boolean }) {
  const count = useAtomValue(liveFeedUnseenCountAtom);

  if (count <= 0) return null;

  return (
    <span
      data-testid="nav-notifications-badge"
      data-count={count}
      data-severity="none"
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold text-white bg-blue-500',
        compact
          ? 'absolute -right-0.5 -top-0.5 h-4 min-w-4 px-0.5 text-[10px] leading-none'
          : 'ml-auto min-w-[1.25rem] px-1.5 py-0.5 text-xs',
      )}
    >
      {compact && count > 99 ? '99+' : count}
    </span>
  );
}
